module.exports = __webpack_public_path__ + "img/full3-min.f2791b40.png";